import { defineStore } from 'pinia'

// Detect if user is on a desktop device (no touch support)
const isDesktop = () => !('ontouchstart' in window) && !navigator.maxTouchPoints

// Check if this is a first-time load (no saved settings)
const isFirstLoad = () => !localStorage.getItem('mapSettingsStore')

// Enable mouse wheel zoom by default for desktop first-time users
const getDefaultMouseWheelZoom = () => isFirstLoad() && isDesktop()

export const useMapSettingsStore = defineStore('mapSettingsStore', {
  state: () => ({
    showScanRange: false,
    enableMouseWheelZoom: getDefaultMouseWheelZoom(),
    hideBackgroundImage: false,
    rememberTooltipPosition: false,
    showAllShipActionPaths: true,
    showLargeFleets: true,
    showTerritoryOverlay: false,
    territoryOpacity: 20,
    showRoutes: true
  }),
  getters: {},
  actions: {
    setShowScanRange(value: boolean) {
      this.showScanRange = value
    },
    setEnableMouseWheelZoom(value: boolean) {
      this.enableMouseWheelZoom = value
    },
    setHideBackgroundImage(value: boolean) {
      this.hideBackgroundImage = value
    },
    setRememberTooltipPosition(value: boolean) {
      this.rememberTooltipPosition = value
    },
    setShowAllShipActionPaths(value: boolean) {
      this.showAllShipActionPaths = value
    },
    setShowLargeFleets(value: boolean) {
      this.showLargeFleets = value
    },
    toggleTerritoryOverlay() {
      this.showTerritoryOverlay = !this.showTerritoryOverlay
    },
    setShowRoutes(value: boolean) {
      this.showRoutes = value
    }
  },
  persist: {
    key: 'mapSettingsStore',
    storage: localStorage,
    serializer: {
      serialize: (state) => {
        // Deep clone using JSON
        const cloned = JSON.parse(JSON.stringify(state))

        return JSON.stringify(cloned)
      },
      deserialize: (value) => JSON.parse(value)
    }
  }
})
